module.exports = __webpack_public_path__ + "img/couples-086.ca134a88.jpg";